export default "__VITE_ASSET__DTSgUkQO__"